import { useState } from 'react';

export default function CommunityMap() {
  const [activeCity, setActiveCity] = useState('all');

  const cities = [
    { id: 'all', name: 'All Locations', count: 2847 },
    { id: 'portland', name: 'Portland, OR', count: 523, lat: 45.5152, lng: -122.6784 },
    { id: 'austin', name: 'Austin, TX', count: 612, lat: 30.2672, lng: -97.7431 },
    { id: 'seattle', name: 'Seattle, WA', count: 489, lat: 47.6062, lng: -122.3321 },
    { id: 'denver', name: 'Denver, CO', count: 401, lat: 39.7392, lng: -104.9903 },
    { id: 'sf', name: 'San Francisco, CA', count: 534, lat: 37.7749, lng: -122.4194 },
    { id: 'boston', name: 'Boston, MA', count: 288, lat: 42.3601, lng: -71.0589 }
  ];

  const getMapUrl = () => {
    if (activeCity === 'all') {
      return 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12644220.24!2d-100.0!3d40.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDAwJzAwLjAiTiAxMDDCsDAwJzAwLjAiVw!5e0!3m2!1sen!2sus!4v1234567890';
    }
    
    const city = cities.find(c => c.id === activeCity);
    if (city && city.lat && city.lng) {
      return `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50000!2d${city.lng}!3d${city.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM!5e0!3m2!1sen!2sus!4v1234567890`;
    }
    
    return 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12644220.24!2d-100.0!3d40.0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDAwJzAwLjAiTiAxMDDCsDAwJzAwLjAiVw!5e0!3m2!1sen!2sus!4v1234567890';
  };

  const recentExchanges = [
    {
      id: 1,
      user: 'Emma R.',
      avatar: 'https://public.readdy.ai/ai/img_res/450d9bb9a332df26c04227e4f344e9e4.jpg',
      item: 'Vintage Bookshelf',
      location: 'Portland, OR',
      time: '2 hours ago',
      icon: 'ri-book-line'
    },
    {
      id: 2,
      user: 'Marcus T.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20smiling%20young%20man%20with%20short%20dark%20hair%2C%20friendly%20expression%2C%20casual%20shirt%2C%20bright%20natural%20lighting%2C%20clean%20simple%20background%2C%20authentic%20genuine%20smile%2C%20confident%20personality&width=100&height=100&seq=avatar-002&orientation=squarish',
      item: 'DSLR Camera',
      location: 'Austin, TX',
      time: '5 hours ago',
      icon: 'ri-camera-line'
    },
    {
      id: 3,
      user: 'Sarah K.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20smiling%20young%20woman%20with%20blonde%20hair%2C%20friendly%20expression%2C%20casual%20attire%2C%20bright%20natural%20lighting%2C%20clean%20simple%20background%2C%20authentic%20genuine%20smile%2C%20warm%20personality&width=100&height=100&seq=avatar-003&orientation=squarish',
      item: 'Acoustic Guitar',
      location: 'Seattle, WA',
      time: '8 hours ago',
      icon: 'ri-music-line'
    },
    {
      id: 4,
      user: 'David L.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20smiling%20middle-aged%20man%20with%20glasses%2C%20friendly%20expression%2C%20casual%20shirt%2C%20bright%20natural%20lighting%2C%20clean%20simple%20background%2C%20authentic%20genuine%20smile%2C%20professional%20personality&width=100&height=100&seq=avatar-004&orientation=squarish',
      item: 'Office Chair',
      location: 'Denver, CO',
      time: '12 hours ago',
      icon: 'ri-armchair-line'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-2 h-2 bg-teal-600 rounded-full"></div>
            <span className="text-teal-600 text-xs font-semibold tracking-widest uppercase">Community Network</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-6 leading-tight">
            Exchanges Happening<br />Near You
          </h2>
          
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join thousands of community members actively swapping items across the country. See real-time exchanges in your area and connect with neighbors.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="bg-white rounded-3xl overflow-hidden shadow-xl">
              <div className="p-6 border-b border-gray-100">
                <div className="flex flex-wrap gap-3">
                  {cities.map((city) => (
                    <button
                      key={city.id}
                      onClick={() => setActiveCity(city.id)}
                      className={`px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                        activeCity === city.id
                          ? 'bg-teal-600 text-white shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {city.name}
                      <span className="ml-2 opacity-75">({city.count})</span>
                    </button>
                  ))}
                </div>
              </div>

              <div className="relative h-[600px] bg-gray-100">
                <iframe
                  src={getMapUrl()}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Community Exchange Locations"
                  className="w-full h-full"
                ></iframe>

                <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-xl">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                        <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                      </div>
                      <div>
                        <p className="text-sm text-gray-600">Active Exchanges</p>
                        <p className="text-2xl font-bold text-gray-900">
                          {cities.find(c => c.id === activeCity)?.count || 2847}
                        </p>
                      </div>
                    </div>
                    <button className="bg-teal-600 text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer shadow-lg">
                      Find Nearby
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="bg-white rounded-3xl p-6 shadow-xl">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900">Recent Activity</h3>
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              </div>

              <div className="space-y-4">
                {recentExchanges.map((exchange) => (
                  <div
                    key={exchange.id}
                    className="flex items-start gap-3 p-4 bg-gray-50 rounded-2xl hover:bg-gray-100 transition-all cursor-pointer group"
                  >
                    <img
                      src={exchange.avatar}
                      alt={exchange.user}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <p className="font-semibold text-gray-900 text-sm">{exchange.user}</p>
                        <div className="w-4 h-4 bg-teal-100 rounded-full flex items-center justify-center">
                          <i className={`${exchange.icon} text-xs text-teal-600`}></i>
                        </div>
                      </div>
                      <p className="text-sm text-gray-600 mb-1 truncate">{exchange.item}</p>
                      <div className="flex items-center gap-3 text-xs text-gray-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-map-pin-line"></i>
                          {exchange.location}
                        </span>
                        <span>{exchange.time}</span>
                      </div>
                    </div>
                    <i className="ri-arrow-right-line text-gray-400 group-hover:text-teal-600 transition-colors"></i>
                  </div>
                ))}
              </div>

              <button className="w-full mt-6 bg-gray-100 text-gray-700 px-6 py-3 rounded-full text-sm font-semibold hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer">
                View All Activity
              </button>
            </div>

            <div className="bg-teal-600 rounded-3xl p-6 shadow-xl mt-6">
              <div className="text-center text-white">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-earth-line text-3xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Join Your Community</h4>
                <p className="text-teal-50 text-sm mb-6">
                  Start swapping with neighbors and make a positive impact today.
                </p>
                <button className="bg-white text-teal-600 px-6 py-3 rounded-full text-sm font-semibold hover:bg-teal-50 transition-all whitespace-nowrap cursor-pointer w-full shadow-lg">
                  Get Started Free
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
          <div className="bg-white rounded-2xl p-6 text-center shadow-lg">
            <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-group-line text-2xl text-teal-600"></i>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-1">12,847</p>
            <p className="text-sm text-gray-600">Active Members</p>
          </div>

          <div className="bg-white rounded-2xl p-6 text-center shadow-lg">
            <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-map-pin-2-line text-2xl text-teal-600"></i>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-1">156</p>
            <p className="text-sm text-gray-600">Cities Covered</p>
          </div>

          <div className="bg-white rounded-2xl p-6 text-center shadow-lg">
            <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-arrow-left-right-line text-2xl text-teal-600"></i>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-1">8,234</p>
            <p className="text-sm text-gray-600">Swaps This Month</p>
          </div>

          <div className="bg-white rounded-2xl p-6 text-center shadow-lg">
            <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-leaf-line text-2xl text-teal-600"></i>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-1">2.4M</p>
            <p className="text-sm text-gray-600">CO₂ Saved (kg)</p>
          </div>
        </div>
      </div>
    </section>
  );
}
